import React, { Component } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardText,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  NavItem,
  NavLink,
  Nav,
  TabPane,
  TabContent,
  Navbar,
  NavbarBrand
} from "reactstrap";
import "./Admin.css";
// import VideoPlayer from './VideoPlayer';
import classnames from "classnames";
import _ from "lodash";

class Admin extends Component {
  constructor(props) {
    super(props);
    console.log("PROPS", props);

    this.renderVideo = this.renderVideo.bind(this);
    this.renderVideos = this.renderVideos.bind(this);
    this.state = { activeTab: "" };
  }

  renderVideos(cohort, cohortKey) {
    let videos = [];

    _.forEach(cohort, (video, videoKey) => {
      videos.push(this.renderVideo(video, videoKey, cohortKey));
    });

    return videos;
  }

  renderVideo(video, videoKey, cohortKey) {
    // const videoJsOptions = {
    //   autoplay: false,
    //   controls: true,
    //   sources: [{
    //     src: video.url,
    //     type: 'video/mp4'
    //   }]
    // };

    let feedback = [];

    if ("feedback" in video) {
      _.each(video.feedback, (f, key) => {
        feedback.push(
          <CardText className="m-2" key={key}>
            <strong>{f.name}:</strong> {f.feedback}{" "}
            <Button
              color="link"
              className="text-danger"
              size="sm"
              onClick={() => {
                this.props.deleteFeedback(cohortKey, videoKey, key);
              }}
            >
              delete
            </Button>
          </CardText>
        );
      });
    }

    return (
      <Card key={videoKey + cohortKey} className="my-4">
        <CardHeader tag="h5">
          {video.name}{" "}
          <Button
            size="sm"
            className="float-right btn-sm"
            onClick={() => {
              this.props.toggleVideoVisibility(videoKey, cohortKey);
            }}
            color={video.visible ? "danger" : "success"}
          >
            {video.visible ? "Hide" : "Show"}
          </Button>
        </CardHeader>
        <Row className={video.visible ? "" : "d-none"}>
          <Col sm="3">
            <video controls src={video.url} className="m-2" />
          </Col>
          <Col className="Admin-feedback">{feedback}</Col>
        </Row>
      </Card>
    );
  }

  render() {
    let exportOptions = [];
    let navItems = [];
    let tabPanes = [];

    _.forEach(this.props.allVideos, (cohort, key) => {
      let videos = this.renderVideos(cohort, key);

      exportOptions.push(
        <option key={key} value={key}>
          {key}
        </option>
      );
      navItems.push(
        <NavItem key={key}>
          <NavLink
            className={classnames({ active: this.state.activeTab === key })}
            onClick={() => {
              console.log(key);
              this.setState({
                activeTab: key
              });
            }}
          >
            {key}
          </NavLink>
        </NavItem>
      );

      tabPanes.push(
        <TabPane tabId={key}>
          <Navbar color="light" light expand="md">
            <NavbarBrand href="/">{key}</NavbarBrand>
            <Nav>
              <NavItem>
                <Button
                  color="primary"
                  size="md"
                  block
                  onClick={() => {
                    this.props.exportFeedback(key);
                  }}
                >
                  Export
                </Button>
              </NavItem>
            </Nav>
          </Navbar>
          {videos}
        </TabPane>
      );
    });

    return (
      <div>
        <h2>Admin</h2>
        <Nav tabs>{navItems}</Nav>
        <TabContent activeTab={this.state.activeTab}>{tabPanes}</TabContent>

        <h2>Add User</h2>
        <Form>
          <FormGroup>
            <Label>First Name</Label>
            <Input
              type="text"
              onChange={e => {
                this.fn = e.target.value;
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label>Last Name</Label>
            <Input
              type="text"
              onChange={e => {
                this.ln = e.target.value;
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label>Email</Label>
            <Input
              type="email"
              onChange={e => {
                this.email = e.target.value;
              }}
            />
          </FormGroup>
          <FormGroup>
            <Label>Cohort</Label>
            <Input
              type="text"
              onChange={e => {
                this.cohort = e.target.value;
              }}
            />
          </FormGroup>
          <Button color="primary">Add</Button>
        </Form>
      </div>
    );
  }
}

export default Admin;



// WEBPACK FOOTER //
// ./src/Admin.js